import React, { createContext, useContext, useState, useEffect } from 'react';
import { getRegions } from '../services/regionService';
import { useAuth } from '../components/Auth/AuthContext';

const RegionContext = createContext();

export const RegionProvider = ({ children }) => {
  const { user } = useAuth();
  const [regions, setRegions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // The regions endpoint requires auth; skip until the user is logged in
    // (e.g. on the login page there is no token yet).
    if (!user) {
      setRegions([]);
      setLoading(false);
      return;
    }

    const fetchRegions = async () => {
      setLoading(true);
      try {
        const data = await getRegions();
        setRegions(data);
        setLoading(false);
      } catch (err) {
        setError(err);
        setLoading(false);
      }
    };

    fetchRegions();
  }, [user]);

  const getRegionById = (regionId) => {
    return regions.find(region => region.id === parseInt(regionId));
  };

  const getRegionName = (regionId) => {
    const region = getRegionById(regionId);
    return region ? region.name.toLowerCase() : '';
  };

  return (
    <RegionContext.Provider value={{ regions, loading, error, getRegionById, getRegionName }}>
      {children}
    </RegionContext.Provider>
  );
};

export const useRegions = () => {
  const context = useContext(RegionContext);
  if (!context) {
    throw new Error('useRegions must be used within a RegionProvider');
  }
  return context;
}; 